
<div class="row">
  <div class="col-12">
    <h1>Document Transfer</h1>
  </div>


</div>

<div class="row">
  <div class="col-12">
    <h3>Session Details</h3>
  </div>
</div>
<form [formGroup]="conversionForm">

  <div class="card bg-light">
    <div class="card-body">

      <div class="row">
        <div class="col-12">
          <h3 class="mt-0">Document Source Details</h3>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="sourceEnvironment">Environment</label>
            <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="sourceEnvironment" id="sourceEnvironment"
                     [options]="conversionEnvironments" (onSelect)="getConversionCorporations()"></select2>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="sourceCorporation">Corporation</label>
            <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="sourceCorporation" id="sourceCorporation"
                     [options]="conversionCorporations" (onSelect)="getConversionFacilities()"></select2>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="sourceFacility">Facility</label>
            <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="sourceFacility" id="sourceFacility"
                     [options]="conversionFacilities" (onSelect)="getConversionUnits()"></select2>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="sourceUnits">Units</label>
            <ngx-bootstrap-multiselect [settings]="optionSettings" [options]="conversionUnitsMulti" [texts]="optionTexts" formControlName="sourceUnits" id="sourceUnits"></ngx-bootstrap-multiselect>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="sourceDocTypes">Types</label>
            <ngx-bootstrap-multiselect [settings]="optionSettings" [options]="conversionDocTypesMulti" [texts]="optionTexts" formControlName="sourceDocTypes" id="sourceDocTypes"></ngx-bootstrap-multiselect>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div class="form-group input-required">
            <label for="sourceDateRange">Date Range</label>
            <div class="has-feedback datepicker-control">
              <input type="text" class="form-control" placeholder="mm/dd/yyyy - mm/dd/yyyy"  name="sourceDateRange" id="sourceDateRange" formControlName="sourceDateRange" />
              <div class="form-control-feedback"></div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12 col-sm-3">
          <button class="btn btn-primary" id="searchButton" [disabled]="!conversionForm.valid" (click)="searchResidents()">Search</button>
        </div>
      </div>

    </div>

  </div>

  <div id="searchResults">
    <div class="row">

      <div class="col-12 col-sm-3 col-md-6 ">
        <h3 class="mt-4">Residents</h3>
      </div>

    </div>
    <div class="row">
      <div class="col-12">
      <table class="table table-bordered table-striped table-fit" id="residentList" #residentList>

        </table>
      </div>
    <div class="spinner" *ngIf="loading">
      <div class="lspinner"></div>
        </div>
    </div>
  </div>

  <div class="row mt-1">
  <div class="col-12">
      <button class="btn btn-default" (click)="goBack()">Back</button>

      <button class="btn btn-primary" id="saveButton" (click)="saveRes()">Save and Continue</button>
    </div>
  </div>
</form>
